import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import CinemaLayout from "../pages/cinema/layout";
import CinemaHome from "../pages/cinema/home/page";
import CinemaWatch from "../pages/cinema/watch/page";
import CinemaMyList from "../pages/cinema/mylist/page";
import CinemaHistory from "../pages/cinema/history/page";
import CinemaRanking from "../pages/cinema/ranking/page";
import CinemaLogin from "../pages/cinema/login/page";
import CinemaProfile from "../pages/cinema/profile/page";
import CinemaReferral from "../pages/cinema/referral/page";
import CinemaAds from "../pages/cinema/ads/page";
import CinemaCreatorCenter from "../pages/cinema/creator-center/page";
import DistributorLoginPage from "../pages/distributor/login/page";
import DistributorDashboardPage from "../pages/distributor/dashboard/page";
import DistributorWithdrawPage from "../pages/distributor/withdraw/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <CinemaLayout />,
    children: [
      { index: true, element: <CinemaHome /> },
      { path: "watch/:seriesId", element: <CinemaWatch /> },
      { path: "mylist", element: <CinemaMyList /> },
      { path: "history", element: <CinemaHistory /> },
      { path: "ranking", element: <CinemaRanking /> },
      { path: "categories", element: <CinemaRanking /> },
      { path: "login", element: <CinemaLogin /> },
      { path: "profile", element: <CinemaProfile /> },
      { path: "referral", element: <CinemaReferral /> },
      { path: "ads", element: <CinemaAds /> },
      { path: "creator-center", element: <CinemaCreatorCenter /> },
    ],
  },
  {
    path: "/distributor/login",
    element: <DistributorLoginPage />,
  },
  {
    path: "/distributor/dashboard",
    element: <DistributorDashboardPage />,
  },
  {
    path: "/distributor/withdraw",
    element: <DistributorWithdrawPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
